const NavBarBuildingIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path d="M19 2.88077L5 2.88075V22.8808H19V2.88077Z" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M3 22.8808H21" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M15 22.8808V17.8808H9V22.8808" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M15 6.88075H9M15 10.3808H9M15 13.8808H9" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
      </svg>
    )
}
export default NavBarBuildingIcon;